import type { BillingOrganization } from '@/types/BillingOrganization'
import type { UUID } from '@/types/Id'

export const billingOrganizationQueryKey = {
  all: () => ['billing-organization'] as const,
  sso: () => ['billing-organization', 'sso'] as const,
  modelAccess: () => ['billing-organization', 'model-access'] as const,
}

export const billingOrgUsersQueryKey = {
  all: (billingOrgId: UUID) =>
    ['billing-organization', billingOrgId, 'users'] as const,
}

export const billingOrgInvitesQueryKey = {
  all: (billingOrgId: UUID) =>
    ['billing-organization', billingOrgId, 'invites'] as const,
}

export interface UserInBillingOrg {
  status: 'in_billing_org'
  billingOrg: BillingOrganization
}

export interface UserPendingWebhook {
  status: 'pending'
  retryCount: number
}

export interface UserOnboardingRequired {
  status: 'onboarding_required'
}

export type BillingOrgStatus =
  | UserInBillingOrg
  | UserPendingWebhook
  | UserOnboardingRequired
